import { render, staticRenderFns } from "./PacketReturnShipment.vue?vue&type=template&id=87170730&scoped=true"
import script from "./PacketReturnShipment.vue?vue&type=script&lang=js"
export * from "./PacketReturnShipment.vue?vue&type=script&lang=js"
import style0 from "./PacketReturnShipment.vue?vue&type=style&index=0&id=87170730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87170730",
  null
  
)

export default component.exports